import {useEffect} from 'react';
import {useSearchParams} from 'react-router';

import {ADD_APP_SEARCH_PARAM, isValidAppSlug} from './pinnedApps';

/**
 * Consume `?addApp=<slug>` (linked from the App Platform overlay's "Add to
 * home" button): strip the param and hand a valid slug to `onAdd`. Waits until
 * `enabled` so the pin lands once the viewer and feature flag are known.
 */
export const useAddAppFromUrl = ({
  enabled,
  onAdd,
}: {
  enabled: boolean;
  onAdd: (slug: string) => void;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const slug = searchParams.get(ADD_APP_SEARCH_PARAM);

  useEffect(() => {
    if (!enabled || slug === null) {
      return;
    }
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(ADD_APP_SEARCH_PARAM);
        return next;
      },
      {replace: true}
    );
    if (isValidAppSlug(slug)) {
      onAdd(slug);
    }
  }, [enabled, slug, onAdd, setSearchParams]);
};
